import Fetch from "./fetchUtils"

export function getIdentityUsers(cb) {
    return Fetch.get('api/identity/users', undefined, undefined, cb);
}